// src/app/api.service.ts
import {Injectable} from '@angular/core';
import {HttpClient, HttpContext, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment'; // <-- Add this import
import {formatDate} from '@angular/common';
import {SKIP_GLOBAL_LOADER} from '../core/http-context';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class ApiService {

  private baseUrl = environment.baseUrl; // <-- Use environment variable

  constructor(private http: HttpClient) { }

  private toDateParam(value: any): string {
    if (!value) {
      return '';
    }
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? '' : formatDate(date, 'yyyy-MM-dd', 'en-IN');
  }
  logIn(data: object): Observable<any> {
      return this.http.post<{ access: string, refresh: string, user: object }>(
          `${this.baseUrl}login/`,
          data,
          {context: new HttpContext().set(SKIP_GLOBAL_LOADER, true)},
      );
  }

  // OTP Verification
  sendMobileVerificationOTP(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}send_phone_otp/`, data)
  }

  verifyMobileOTP(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}verify_phone_otp/`, data)
  }


  // refreshToken(token: string | null){
  //   this.http.post<any>('token/refresh/', token)
  // }

  getVehicleDatabase(pageNo: number, pageSize: number, searchText: string | null, ordering: string | null = null): Observable<any> {
    let params = new HttpParams()
        .set('page', pageNo)
        .set('page_size', pageSize);
    if (searchText) {
      params = params.set('search', searchText);
    }
    if (ordering) {
      params = params.set('ordering', ordering);
    }
    return this.http.get(`${this.baseUrl}vehicles/`, {params});
  }

  getSearchVehicle(pageNo: number, pageSize: number, searchText: string | null): Observable<any> {
    return this.http.get(`${this.baseUrl}vehicles/?search=${searchText}&page=${pageNo}&page_size=${pageSize}`);
  }

  exportVehicleDB(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {
    if (searchText) {
      return this.http.get(`${this.baseUrl}vehicles/export_to_excel/?search=${searchText}&page=${pageNo}&page_size=${pageSize}`,
        {
          responseType: 'blob',
          observe: 'response'
        });
    } else {
      return this.http.get(`${this.baseUrl}vehicles/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
        {
          responseType: 'blob',
          observe: 'response'
        }
      );
    }
  }

  getVehicleDBSearchSuggestions(searchText: string): Observable<any> {
    return this.http.get(`${this.baseUrl}vehicles/search_suggestion?q=${encodeURIComponent(searchText || '')}`);
  }

  addVehicle(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}vehicles/`, data);
  }

  deleteVehicle(id: number) {
    return this.http.delete(`${this.baseUrl}vehicles/${id}/`)
  }

    previewVehicleBulkDelete(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}vehicles/bulk-delete-preview/`, payload);
  }

    bulkDeleteVehicles(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}vehicles/bulk-delete/`, payload);
  }

    previewHotlistBulkDelete(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}hotlisted-vehicles/bulk-delete-preview/`, payload);
  }

    bulkDeleteHotlist(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}hotlisted-vehicles/bulk-delete/`, payload);
  }

    previewBlacklistBulkDelete(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}blacklisted-vehicles/bulk-delete-preview/`, payload);
  }

    bulkDeleteBlacklist(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}blacklisted-vehicles/bulk-delete/`, payload);
  }

    previewMonitoringBulkDelete(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}vehicle-monitoring/rules/bulk-delete-preview/`, payload);
  }

    bulkDeleteMonitoring(payload: Record<string, unknown>) {
        return this.http.post(`${this.baseUrl}vehicle-monitoring/rules/bulk-delete/`, payload);
  }


  trackVehicle(page: number, pageSize: number, data: object) {
    return this.http.post(`${this.baseUrl}track-vehicle/?page=${page}&page_size=${pageSize}`, data)
  }

  exportTrackVehicle(data: Object): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.baseUrl}track-vehicle/`, data,
      {
        responseType: 'blob',
        observe: 'response'
      }
    )
  }
  getTrackVehicleNumberSuggestions(searchText: string) {
    return this.http.get(`${this.baseUrl}track-vehicle/vehicle_suggestion?q=${searchText}`);
  }

  getTrackVehicleSearchSuggestion(data: object): Observable<any> {
    return this.http.post(`${this.baseUrl}track-vehicle/search_suggestion`, data);
  }

  generateReport(page: number, pageSize: number, data: object) {
    return this.http.post(`${this.baseUrl}generate-report/?page=${page}&page_size=${pageSize}`, data

    )
  }
  exportReport(data: object): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.baseUrl}generate-report/`, data,
      {
        responseType: 'blob',
        observe: 'response'
      }
    )
  }
  getProfiledetail(pkId: number) {
    return this.http.get(`${this.baseUrl}users/${pkId}/`)
  }
  // updateProfile(pkId:number, data: object):  Observable<any>{
  //   return this.http.put(`${this.baseUrl}users/${pkId}/`, data)
  // }
  updateProfile(pkId: number, data: object): Observable<any> {
    return this.http.patch(`${this.baseUrl}users/${pkId}/`, data)
  }
  // exportVehicleDatabase():  Observable<any>{
  //   return this.http.get(`${this.baseUrl}export-vehicle/`)
  // }
  changePassword(data: object): Observable<any> {
    return this.http.patch(`${this.baseUrl}change-password/`, data)
  }
  downloadTemplate(): Observable<HttpResponse<Blob>> {
      return this.downloadImportTemplate('vehicle');
  }

    downloadImportTemplate(templateType: string): Observable<HttpResponse<Blob>> {
        const params = new HttpParams().set('type', templateType);
        return this.http.get(`${this.baseUrl}download-template/`, {
            params,
            responseType: 'blob',
            observe: 'response',
        });
  }

  getLogs(options: {
    page?: number;
    pageSize?: number;
    dateRange?: string;
    date?: string;
    status?: string;
    levels?: string[];
    categories?: string[];
    search?: string;
  } = {}): Observable<any> {
    let params = new HttpParams()
      .set('page', String(options.page || 1))
      .set('page_size', String(options.pageSize || 50))
      .set('date_range', options.dateRange || 'today');

    if (options.date) {
      params = params.set('date', options.date);
    }
    if (options.status && options.status !== 'all') {
      params = params.set('status', options.status);
    }
    if (options.levels && options.levels.length > 0) {
      params = params.set('levels', options.levels.join(','));
    }
    if (options.categories && options.categories.length > 0) {
      params = params.set('categories', options.categories.join(','));
    }
    if (options.search) {
      params = params.set('search', options.search);
    }
    return this.http.get(`${this.baseUrl}logs/`, { params });
  }
  getLoginActivity(page: number, pageSize: number, orgId: number | string | null = null): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/login-activity/`, { params });
  }

  listSubscriptions(page: number, pageSize: number, searchText: string = '', status: string = '', billingType: string = '', orgId: number | string | null = null) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', searchText || '');
    if (status) {
      params = params.set('status', status);
    }
    if (billingType) {
      params = params.set('billing_type', billingType);
    }
    if (orgId) {
      params = params.set('organization', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}subscriptions/`, { params });
  }

  getSubscription(id: number) {
    return this.http.get(`${this.baseUrl}subscriptions/${id}/`);
  }

  createSubscription(data: object) {
    return this.http.post(`${this.baseUrl}subscriptions/`, data);
  }

  updateSubscription(id: number, data: object) {
    return this.http.put(`${this.baseUrl}subscriptions/${id}/`, data);
  }

  deleteSubscription(id: number) {
    return this.http.delete(`${this.baseUrl}subscriptions/${id}/`);
  }

  uploadSubscriptionQuotation(data: FormData) {
    return this.http.post(`${this.baseUrl}subscriptions/upload-quotation/`, data);
  }

  listSubscriptionDocuments(id: number) {
    return this.http.get(`${this.baseUrl}subscriptions/${id}/documents/`);
  }

  uploadSubscriptionDocument(id: number, data: FormData) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/documents/`, data);
  }

  listSubscriptionPayments(id: number) {
    return this.http.get(`${this.baseUrl}subscriptions/${id}/payments/`);
  }

  addSubscriptionPayment(id: number, data: object) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/payments/`, data);
  }

  updateSubscriptionPayment(id: number, data: object) {
    return this.http.patch(`${this.baseUrl}subscriptions/${id}/payments/`, data);
  }

  sendSubscriptionExpiryAlert(id: number, data: object = {}) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/send-expiry-alert/`, data);
  }

  sendSubscriptionPaymentReminder(id: number, data: object = {}) {
    return this.http.post(`${this.baseUrl}subscriptions/${id}/send-payment-reminder/`, data);
  }

  listLeads(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.source) {
      params = params.set('source', filters.source);
    }
    if (filters.assigned_to) {
      params = params.set('assigned_to', filters.assigned_to);
    }
    if (filters.date_from) {
      params = params.set('date_from', this.toDateParam(filters.date_from));
    }
    if (filters.date_to) {
      params = params.set('date_to', this.toDateParam(filters.date_to));
    }
    if (filters.organization) {
      params = params.set('organization', filters.organization);
    }
    if (filters.followup) {
      params = params.set('followup', filters.followup);
    }
    return this.http.get(`${this.baseUrl}leads/`, { params });
  }

  getLeadDashboard() {
    return this.http.get(`${this.baseUrl}leads/dashboard/`);
  }

  getLead(id: number) {
    return this.http.get(`${this.baseUrl}leads/${id}/`);
  }

  convertLeadToSalesInstallationPartner(id: number) {
    return this.http.post(`${this.baseUrl}leads/${id}/convert-to-sales-installation-partner/`, {});
  }

    revertSalesInstallationPartnerToLead(partnerId: number) {
        return this.http.post(`${this.baseUrl}sales-installation-partners/${partnerId}/revert-to-lead/`, {});
    }

  createLead(data: object) {
    return this.http.post(`${this.baseUrl}leads/`, data);
  }

  updateLead(id: number, data: object) {
    return this.http.patch(`${this.baseUrl}leads/${id}/`, data);
  }

  deleteLead(id: number) {
    return this.http.delete(`${this.baseUrl}leads/${id}/`);
  }

  getLeadActivities(id: number) {
    return this.http.get(`${this.baseUrl}leads/${id}/activities/`);
  }

  addLeadFollowUp(id: number, data: object) {
    return this.http.post(`${this.baseUrl}leads/${id}/follow-ups/`, data);
  }

  updateLeadFollowUp(leadId: number, followUpId: number, data: object) {
    return this.http.patch(`${this.baseUrl}leads/${leadId}/follow-ups/${followUpId}/`, data);
  }

  deleteLeadFollowUp(leadId: number, followUpId: number) {
    return this.http.delete(`${this.baseUrl}leads/${leadId}/follow-ups/${followUpId}/`);
  }

  listLeadFollowUps(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.assigned_to) {
      params = params.set('assigned_to', filters.assigned_to);
    }
    if (filters.date) {
      params = params.set('date', this.toDateParam(filters.date));
    }
    return this.http.get(`${this.baseUrl}leads/follow-ups/`, { params });
  }

  addLeadDemo(id: number, data: object) {
    return this.http.post(`${this.baseUrl}leads/${id}/demos/`, data);
  }

  updateLeadDemo(leadId: number, demoId: number, data: object) {
    return this.http.patch(`${this.baseUrl}leads/${leadId}/demos/${demoId}/`, data);
  }

  deleteLeadDemo(leadId: number, demoId: number) {
    return this.http.delete(`${this.baseUrl}leads/${leadId}/demos/${demoId}/`);
  }

  listLeadDemos(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.date) {
      params = params.set('date', this.toDateParam(filters.date));
    }
    return this.http.get(`${this.baseUrl}leads/demos/`, { params });
  }
  uploadGuidelines() {
    return this.http.get(`${this.baseUrl}upload-guidelines/`)
  }
  bulkUpload(data: Object) {
    return this.http.post(`${this.baseUrl}bulk-upload/`, data)
  }

    bulkUploadHotlist(data: Object) {
        return this.http.post(`${this.baseUrl}bulk-upload-hotlist/`, data);
    }

    bulkUploadBlocklist(data: Object) {
        return this.http.post(`${this.baseUrl}bulk-upload-blocklist/`, data);
    }

    validateInitialOccupancyUpload(organizationId: number, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('organization_id', String(organizationId));
        formData.append('validate_only', 'true');
        return this.http.post(`${this.baseUrl}bulk-upload-initial-occupancy/`, formData);
    }

    bulkUploadInitialOccupancy(organizationId: number, file: File) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('organization_id', String(organizationId));
        return this.http.post(`${this.baseUrl}bulk-upload-initial-occupancy/`, formData);
    }
  getVehicle(pk: number) {
    return this.http.get(`${this.baseUrl}vehicles/${pk}/`)

  }
  // updateVehicle(pk: number, data: Object){
  //   return this.http.put(`${this.baseUrl}vehicles/${pk}/`, data)
  // }
  updateVehicle(pk: number, data: Partial<any>): Observable<any> {
    return this.http.patch(`${this.baseUrl}vehicles/${pk}/`, data)
  }
  forgotPassword(data: Object) {
    return this.http.post(`${this.baseUrl}password-reset/`, data)
  }
  forgotPasswordConfirm(data: Object) {
    return this.http.post(`${this.baseUrl}password-reset-confirm/`, data)
  }
  contactUsPrivate(data: Object) {
    return this.http.post(`${this.baseUrl}contact/`, data)
  }

    listContactUsRequests(page: number, pageSize: number) {
        const params = new HttpParams()
            .set('page', page)
            .set('page_size', pageSize);
        return this.http.get(`${this.baseUrl}contact-us/`, {params});
    }
  // Black Listed Vehicle API's
  addBlackListedVehicle(data: Object) {
    return this.http.post(`${this.baseUrl}blacklisted-vehicles/`, data)
  }

  getBlackedVehicle(page: number, pageSize: number, searchText: string | null, ordering: string | null = null) {
    let params = new HttpParams()
        .set('page', page)
        .set('page_size', pageSize);
    if (searchText) {
      params = params.set('search', searchText);
    }
    if (ordering) {
      params = params.set('ordering', ordering);
    }
    return this.http.get(`${this.baseUrl}blacklisted-vehicles/`, {params});
  }
  unblack(id: number) {
    return this.http.delete(`${this.baseUrl}blacklisted-vehicles/${id}/`)
  }
  exportBlacklisted(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}blacklisted-vehicles/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }


  // Users API
  signUp(data: Object) {
    return this.http.post(`${this.baseUrl}users/`, data)
  }
  getGroups() {
    return this.http.get(`${this.baseUrl}groups/`)
  }
  organization() {
    return this.http.get(`${this.baseUrl}organizations/`)
  }
  getOrganizations(pageSize: number = 1000) {
      return this.http.get(`${this.baseUrl}organizations/?filter_customers=true&page=1&page_size=${pageSize}`)
  }
  getUserdetail(page: number, pageSize: number, searchText: string | null, orgId: number | string | null = null) {
    let params = new HttpParams()
      .set('is_staff_page', 'true')
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', searchText ?? '');
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/`, { params });
  }

  getAssignableUsers(page: number, pageSize: number, searchText: string | null, orgId: number | string | null = null) {
    let params = new HttpParams()
      .set('is_staff_page', 'true')
      .set('assignable_only', 'true')
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', searchText ?? '');
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/`, { params });
  }
  deleteUser(id: number) {
    return this.http.delete(`${this.baseUrl}users/${id}/`)
  }

    toggleStaffActive(userId: number, isActive: boolean) {
        return this.http.patch(`${this.baseUrl}users/${userId}/toggle-active/`, {is_active: isActive});
    }
  exportStaff(pageNo: number, pageSize: number, searchText: string | null, orgId: number | string | null = null): Observable<HttpResponse<Blob>> {
    let params = new HttpParams()
      .set('page', pageNo)
      .set('page_size', pageSize);
    if (orgId) {
      params = params.set('org_id', orgId.toString());
    }
    return this.http.get(`${this.baseUrl}users/export_to_excel/`,
      {
        params,
        responseType: 'blob',
        observe: 'response'
      }
    );
  }


  // Organization
  getOrganization(id: number) {
    return this.http.get(`${this.baseUrl}organizations/${id}/`)
  }

    getOrganizationOnboardingChecklist(id: number) {
        return this.http.get<any>(`${this.baseUrl}organizations/${id}/onboarding-checklist/`)
    }
  // editOrganization(id: number, data: Object){
  //   return this.http.put(`${this.baseUrl}organizations/${id}/`, data)
  // }
  editOrganization(id: number, data: Partial<any>): Observable<any> {
    return this.http.patch(`${this.baseUrl}organizations/${id}/`, data)
  }
  getCityState(id: number) {
    return this.http.get(`${this.baseUrl}locations/pincode/${id}/`)
  }

    getAllOrganization(page: number, pageSize: number, searchText: string | null, ordering: string | null = null) {
        let url = `${this.baseUrl}organizations/?filter_customers=true&page=${page}&page_size=${pageSize}&search=${searchText ?? ''}`;
        if (ordering) {
            url += `&ordering=${ordering}`;
        }
        return this.http.get(url);
  }
  addOrganization(data: Object) {
    return this.http.post(`${this.baseUrl}organizations/`, data)
  }
  deleteOrganization(id: number) {
    return this.http.delete(`${this.baseUrl}organizations/${id}/`)
  }

  exportOraganization(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}organizations/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  setAlertDirections(data: object){
    return this.http.patch(`${this.baseUrl}organizations/alert-direction-config`, data)
  }
  getAlertDirections(){
    return this.http.get(`${this.baseUrl}organizations/alert-direction-config`)
  }

    getNotificationPreferences() {
        return this.http.get(`${this.baseUrl}notification-preferences/`);
    }

    updateNotificationPreferences(data: object) {
        return this.http.put(`${this.baseUrl}notification-preferences/`, data);
    }


  // Events
  getAllEvents(page: number, pageSize: number) {
    return this.http.get(`${this.baseUrl}messaging/audit-logs/?page=${page}&page_size=${pageSize}`)
  }

  // Service health status
  healthStatus() {
    return this.http.get(`${this.baseUrl}health-status/`)

  }

  platformHealth() {
    return this.http.get(`${this.baseUrl}platform-health/`)
  }

    /** Latest EEN Device Health snapshot (Batch 3/4). Super User may pass orgId. */
    getDeviceHealth(orgId?: number | null): Observable<any> {
        let params = new HttpParams();
        if (orgId != null && !Number.isNaN(Number(orgId))) {
            params = params.set('org_id', String(orgId));
        }
        return this.http.get(`${this.baseUrl}device-health/`, {params});
    }

    /** On-demand Device Health refresh (Admin + Super User). */
    refreshDeviceHealth(): Observable<any> {
        return this.http.post(`${this.baseUrl}device-health/refresh/`, {});
    }

    /** Device Health History observations (Phase 21). Asia/Kolkata calendar dates. */
    getDeviceHealthHistoryObservations(params: {
        from_date?: string;
        to_date?: string;
        org_id?: number | null;
        device_key?: string;
        device_type?: string;
        device_id?: string;
        page?: number;
        page_size?: number;
    } = {}): Observable<any> {
        let httpParams = new HttpParams();
        if (params.from_date) {
            httpParams = httpParams.set('from_date', params.from_date);
        }
        if (params.to_date) {
            httpParams = httpParams.set('to_date', params.to_date);
        }
        if (params.org_id != null && !Number.isNaN(Number(params.org_id))) {
            httpParams = httpParams.set('org_id', String(params.org_id));
        }
        if (params.device_key) {
            httpParams = httpParams.set('device_key', params.device_key);
        }
        if (params.device_type) {
            httpParams = httpParams.set('device_type', params.device_type);
        }
        if (params.device_id) {
            httpParams = httpParams.set('device_id', params.device_id);
        }
        if (params.page != null) {
            httpParams = httpParams.set('page', String(params.page));
        }
        if (params.page_size != null) {
            httpParams = httpParams.set('page_size', String(params.page_size));
        }
        return this.http.get(`${this.baseUrl}device-health/history/observations/`, {
            params: httpParams,
        });
    }

    /** Device Health History incidents (Phase 21). Asia/Kolkata calendar dates. */
    getDeviceHealthHistoryIncidents(params: {
        from_date?: string;
        to_date?: string;
        org_id?: number | null;
        device_key?: string;
        device_type?: string;
        device_id?: string;
        incident_type?: string;
        state?: string;
        page?: number;
        page_size?: number;
    } = {}): Observable<any> {
        let httpParams = new HttpParams();
        if (params.from_date) {
            httpParams = httpParams.set('from_date', params.from_date);
        }
        if (params.to_date) {
            httpParams = httpParams.set('to_date', params.to_date);
        }
        if (params.org_id != null && !Number.isNaN(Number(params.org_id))) {
            httpParams = httpParams.set('org_id', String(params.org_id));
        }
        if (params.device_key) {
            httpParams = httpParams.set('device_key', params.device_key);
        }
        if (params.device_type) {
            httpParams = httpParams.set('device_type', params.device_type);
        }
        if (params.device_id) {
            httpParams = httpParams.set('device_id', params.device_id);
        }
        if (params.incident_type) {
            httpParams = httpParams.set('incident_type', params.incident_type);
        }
        if (params.state) {
            httpParams = httpParams.set('state', params.state);
        }
        if (params.page != null) {
            httpParams = httpParams.set('page', String(params.page));
        }
        if (params.page_size != null) {
            httpParams = httpParams.set('page_size', String(params.page_size));
        }
        return this.http.get(`${this.baseUrl}device-health/history/incidents/`, {
            params: httpParams,
        });
    }

  // Dashboard:
  dashboard(page: number, pageSize: number, data: object) {
    return this.http.post(`${this.baseUrl}dashboard/stats/?page=${page}&page_size=${pageSize}`, data)
  }
  getSuperuserDashboard() {
    return this.http.get(`${this.baseUrl}dashboard/superuser/`);
  }
  vehicleMovement(data: object) {
    return this.http.post(`${this.baseUrl}dashboard/vehicle-movement/`, data)
  }
  exportTodayActivity(data: Object): Observable<HttpResponse<Blob>> {
    return this.http.post(`${this.baseUrl}dashboard/stats/`, data,
      {
        responseType: 'blob',
        observe: 'response'
      }
    )
  }

  // Notifications:

  notifications() {
    return this.http.get(`${this.baseUrl}notifications`)
  }

  // Cameras:
  addcamera(data: Object) {
    return this.http.post(`${this.baseUrl}cameras/`, data)
  }
  getWebhookProviders(page: number, pageSize: number, searchText: string = '') {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (searchText.trim()) {
      params = params.set('search', searchText.trim());
    }
    return this.http.get(`${this.baseUrl}webhook-providers/`, { params });
  }
  getWebhookProvider(id: number) {
    return this.http.get(`${this.baseUrl}webhook-providers/${id}/`);
  }
  createWebhookProvider(data: object) {
    return this.http.post(`${this.baseUrl}webhook-providers/`, data);
  }
  updateWebhookProvider(id: number, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}webhook-providers/${id}/`, data);
  }
  listSalesInstallationPartners(page: number, pageSize: number, filters: any = {}) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize)
      .set('search', filters.search || '');
    if (filters.status) {
      params = params.set('status', filters.status);
    }
    if (filters.business_type) {
      params = params.set('business_type', filters.business_type);
    }
    if (filters.city) {
      params = params.set('city', filters.city);
    }
    if (filters.state) {
      params = params.set('state', filters.state);
    }
    if (filters.active_only) {
      params = params.set('active_only', filters.active_only);
    }
    return this.http.get(`${this.baseUrl}sales-installation-partners/`, { params });
  }
  getSalesInstallationPartner(id: number) {
    return this.http.get(`${this.baseUrl}sales-installation-partners/${id}/`);
  }
  createSalesInstallationPartner(data: object) {
    return this.http.post(`${this.baseUrl}sales-installation-partners/`, data);
  }
  updateSalesInstallationPartner(id: number, data: object) {
    return this.http.patch(`${this.baseUrl}sales-installation-partners/${id}/`, data);
  }
  deleteSalesInstallationPartner(id: number) {
    return this.http.delete(`${this.baseUrl}sales-installation-partners/${id}/`);
  }
  createSalesInstallationPartnerFromLead(leadId: number) {
    return this.http.post(`${this.baseUrl}sales-installation-partners/from-lead/`, { lead_id: leadId });
  }
  getWebhookApiKeys(
    page: number,
    pageSize: number,
    searchText: string = '',
    providerId: number | string | null = null,
    organizationId: number | string | null = null
  ) {
    let params = new HttpParams()
      .set('page', page)
      .set('page_size', pageSize);
    if (searchText.trim()) {
      params = params.set('search', searchText.trim());
    }
    if (providerId) {
      params = params.set('provider', providerId.toString());
    }
    if (organizationId) {
      params = params.set('organization', organizationId.toString());
    }
    return this.http.get(`${this.baseUrl}webhook-api-keys/`, { params });
  }
  createWebhookApiKey(data: object) {
    return this.http.post(`${this.baseUrl}webhook-api-keys/`, data);
  }
  updateWebhookApiKey(id: number, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}webhook-api-keys/${id}/`, data);
  }
  viewCameras(page: number, pageSize: number, searchText: string | null, orgId: number | string = '') {
      let params = new HttpParams()
          .set('page', String(page))
          .set('page_size', String(pageSize));
      const normalizedSearch = (searchText ?? '').toString().trim();
      // Never send search=null — DRF SearchFilter treats the literal "null" as a term.
      if (normalizedSearch) {
          params = params.set('search', normalizedSearch);
      }
      if (orgId !== '' && orgId != null) {
          params = params.set('org_id', String(orgId));
      }
      return this.http.get(`${this.baseUrl}cameras/`, {params});
  }
  deleteCamera(id: number, orgId: number) {
    return this.http.delete(`${this.baseUrl}cameras/${id}/?org_id=${orgId}`)
  }
  getCamera(pk: number, orgId: number) {
    return this.http.get(`${this.baseUrl}cameras/${pk}/?org_id=${orgId}`)

  }
  updateCamera(pk: number, orgId: number, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}cameras/${pk}/?org_id=${orgId}`, data)

  }
  exportCamera(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}cameras/export_to_excel`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }

  getBridgeTypes() {
    return this.http.get<Array<{ value: string; label: string; max_lpr_supported: number; price: number }>>(
        `${this.baseUrl}bridge-types/`
    );
  }

  viewBridges(page: number, pageSize: number, searchText: string | null, orgId: number | string) {
      let params = new HttpParams()
          .set('page', String(page))
          .set('page_size', String(pageSize))
          .set('org_id', String(orgId));
      const normalizedSearch = (searchText ?? '').toString().trim();
      // Never send search=null — DRF SearchFilter treats the literal "null" as a term.
      if (normalizedSearch) {
          params = params.set('search', normalizedSearch);
      }
      return this.http.get(`${this.baseUrl}bridges/`, {params});
  }

  addBridge(data: object) {
    return this.http.post(`${this.baseUrl}bridges/`, data);
  }

  getBridge(pk: string, orgId: number | string) {
    return this.http.get(`${this.baseUrl}bridges/${pk}/?org_id=${orgId}`);
  }

  updateBridge(pk: string, orgId: number | string, data: Partial<any>) {
    return this.http.patch(`${this.baseUrl}bridges/${pk}/?org_id=${orgId}`, data);
  }

  exportBridges(
      pageNo: number,
      pageSize: number,
      searchText: string | null,
      orgId: number | string
  ): Observable<HttpResponse<Blob>> {
    return this.http.get(
        `${this.baseUrl}bridges/export_to_excel/?org_id=${orgId}&page=${pageNo}&page_size=${pageSize}&search=${searchText || ''}`,
        {
          responseType: 'blob',
        observe: 'response'
      }
    );
  }

    getBridgeCredentials(bridgeId: string, orgId: number | string) {
        return this.http.get<Array<{
            id: number;
            masked_key: string;
            is_active: boolean;
            last_used_at: string | null;
            created_at: string;
        }>>(`${this.baseUrl}bridges/${bridgeId}/credentials/?org_id=${orgId}`);
    }

    createBridgeCredential(bridgeId: string, orgId: number | string) {
        return this.http.post<{
            id: number;
            raw_key: string;
            masked_key: string;
            is_active: boolean;
            created_at: string;
        }>(`${this.baseUrl}bridges/${bridgeId}/credentials/?org_id=${orgId}`, {});
    }

    revokeBridgeCredential(bridgeId: string, credentialId: number, orgId: number | string) {
        return this.http.patch(
            `${this.baseUrl}bridges/${bridgeId}/credentials/${credentialId}/?org_id=${orgId}`,
            {is_active: false}
        );
    }

  // HotList:
  addHotList(data: Object) {
    return this.http.post(`${this.baseUrl}hotlisted-vehicles/`, data)
  }

  getHotList(page: number, pageSize: number, searchText: string | null, ordering: string | null = null) {
    let params = new HttpParams()
        .set('page', page)
        .set('page_size', pageSize);
    if (searchText) {
      params = params.set('search', searchText);
    }
    if (ordering) {
      params = params.set('ordering', ordering);
    }
    return this.http.get(`${this.baseUrl}hotlisted-vehicles/`, {params});
  }
  removeHotlist(id: number) {
    return this.http.delete(`${this.baseUrl}hotlisted-vehicles/${id}/`)
  }
  exportHotlisted(pageNo: number, pageSize: number, searchText: string | null): Observable<HttpResponse<Blob>> {

    return this.http.get(`${this.baseUrl}hotlisted-vehicles/export_to_excel/?page=${pageNo}&page_size=${pageSize}`,
      {
        responseType: 'blob',
        observe: 'response'
      }
    );
  }
  // Analytics
  analytics(data: Object) {
    return this.http.post(`${this.baseUrl}vehicle-area-distribution/?group_by=location`, data)
  }

  getStaleUnmatchedVehicles(data: object, page: number, pageSize: number) {
    return this.http.post(
      `${this.baseUrl}stale-unmatched-vehicles/?page=${page}&page_size=${pageSize}`,
      data
    );
  }
  // Alerts
  alert(page: number, 
    pageSize: number, 
    searchText: string | null, 
    alertType: string | null,
        dateFilter: string | null,
        monitoringTypes: string[] = [],
        ordering: string | null = null,
  ): Observable<any> {
      let params = new HttpParams()
          .set('page', page)
          .set('page_size', pageSize)
          .set('search', searchText || '')
          .set('alert_type', alertType || '')
          .set('date_filter', dateFilter || '');
      monitoringTypes.forEach(monitoringType => {
          params = params.append('monitoring_type', monitoringType);
      });
    if (ordering) {
      params = params.set('ordering', ordering);
    }
      return this.http.get(`${this.baseUrl}vehicle-alerts`, {params});
  }

    exportAlerts(
        searchText: string | null,
        alertType: string | null,
        dateFilter: string | null,
        monitoringTypes: string[] = [],
    ): Observable<HttpResponse<Blob>> {
        let params = new HttpParams();
        if (searchText) {
            params = params.set('search', searchText);
        }
        if (alertType) {
            params = params.set('alert_type', alertType);
        }
        if (dateFilter) {
            params = params.set('date_filter', dateFilter);
        }
        monitoringTypes.forEach(monitoringType => {
            params = params.append('monitoring_type', monitoringType);
        });
        return this.http.get(`${this.baseUrl}vehicle-alerts/export_to_excel/`, {
            params,
            responseType: 'blob',
            observe: 'response',
        });
    }

    // Vehicle Monitoring (management)
    getGroupedVehicleMonitoring(
        page: number,
        pageSize: number,
        searchText: string | null,
        alertTypes: string[],
        severities: string[] = [],
        ordering: string | null = null,
    ): Observable<any> {
        let params = new HttpParams()
            .set('page', page)
            .set('page_size', pageSize);
        if (searchText) {
            params = params.set('search', searchText);
        }
        if (alertTypes?.length) {
            alertTypes.forEach(alertType => {
                params = params.append('alert_type', alertType);
            });
        }
        if (severities?.length) {
            severities.forEach(severity => {
                params = params.append('severity', severity);
            });
        }
      if (ordering) {
        params = params.set('ordering', ordering);
      }
        return this.http.get(`${this.baseUrl}vehicle-monitoring/`, {params});
    }

    getVehicleMonitoringDetail(id: number): Observable<any> {
        return this.http.get(`${this.baseUrl}vehicle-monitoring/${id}/`);
    }

    deleteVehicleMonitoringRules(ruleIds: number[]): Observable<any> {
        return this.http.post(`${this.baseUrl}vehicle-monitoring/delete/`, {rule_ids: ruleIds});
    }

    bulkUploadVehicleMonitoring(data: Object) {
        return this.http.post(`${this.baseUrl}bulk-upload-vehicle-monitoring/`, data);
    }

    /** @deprecated Use bulkUploadVehicleMonitoring */
    bulkUploadVehicleAlertRules(data: Object) {
        return this.bulkUploadVehicleMonitoring(data);
    }

    addVehicleMonitoringRule(data: object) {
        return this.http.post(`${this.baseUrl}vehicle-alert-rules/`, data);
    }

    /** @deprecated Use addVehicleMonitoringRule */
    addVehicleAlertRule(data: object) {
        return this.addVehicleMonitoringRule(data);
    }

    getVehicleMonitoringRule(id: number) {
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/${id}/`);
    }

    /** @deprecated Use getVehicleMonitoringRule */
    getVehicleAlertRule(id: number) {
        return this.getVehicleMonitoringRule(id);
    }

    updateVehicleMonitoringRule(id: number, data: object) {
        return this.http.patch(`${this.baseUrl}vehicle-alert-rules/${id}/`, data);
    }

    /** @deprecated Use updateVehicleMonitoringRule */
    updateVehicleAlertRule(id: number, data: object) {
        return this.updateVehicleMonitoringRule(id, data);
    }

    deleteVehicleMonitoringRule(id: number) {
        return this.http.delete(`${this.baseUrl}vehicle-alert-rules/${id}/`);
    }

    /** @deprecated Use deleteVehicleMonitoringRule */
    deleteVehicleAlertRule(id: number) {
        return this.deleteVehicleMonitoringRule(id);
    }

    getVehicleMonitoringRulesByVehicle(vehicleNumber: string): Observable<any> {
        const params = new HttpParams().set('vehicle_number', vehicleNumber).set('page_size', 100);
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/`, {params});
    }

    /** @deprecated Use getVehicleMonitoringRulesByVehicle */
    getVehicleAlertRulesByVehicle(vehicleNumber: string): Observable<any> {
        return this.getVehicleMonitoringRulesByVehicle(vehicleNumber);
    }

    getVehicleMonitoringRules(
        page: number,
        pageSize: number,
        searchText: string | null,
        alertType: string | null,
    ): Observable<any> {
        let params = new HttpParams()
            .set('page', page)
            .set('page_size', pageSize);
        if (searchText) {
            params = params.set('search', searchText);
        }
        if (alertType) {
            params = params.set('alert_type', alertType);
        }
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/`, {params});
    }

    /** @deprecated Use getVehicleMonitoringRules */
    getVehicleAlertRules(
        page: number,
        pageSize: number,
        searchText: string | null,
        alertType: string | null,
    ): Observable<any> {
        return this.getVehicleMonitoringRules(page, pageSize, searchText, alertType);
    }

    exportVehicleMonitoringRules(
        searchText: string | null,
        alertTypes: string[] | string | null,
        severities: string[] | string | null = [],
    ): Observable<HttpResponse<Blob>> {
        let params = new HttpParams();
        if (searchText) {
            params = params.set('search', searchText);
        }
        const normalizedTypes = Array.isArray(alertTypes)
            ? alertTypes
            : alertTypes
                ? [alertTypes]
                : [];
        normalizedTypes.forEach(alertType => {
            params = params.append('alert_type', alertType);
        });
        const normalizedSeverities = Array.isArray(severities)
            ? severities
            : severities
                ? [severities]
                : [];
        normalizedSeverities.forEach(severity => {
            params = params.append('severity', severity);
        });
        return this.http.get(`${this.baseUrl}vehicle-alert-rules/export_to_excel/`, {
            params,
            responseType: 'blob',
            observe: 'response',
        });
    }

    /** @deprecated Use exportVehicleMonitoringRules */
    exportVehicleAlertRules(
        searchText: string | null,
        alertTypes: string[] | string | null,
    ): Observable<HttpResponse<Blob>> {
        return this.exportVehicleMonitoringRules(searchText, alertTypes);
    }

    // Phase 19.I — Super User customer integration (Organization context)
    getOrganizationCustomerIntegration(organizationId: number) {
        return this.http.get<{
            organization_id: number;
            environment: string;
            integration: {
                id: number;
                name: string;
                webhook_url: string;
                hmac_secret_configured: boolean;
                hmac_secret_masked: string;
                environment: string;
                is_active: boolean;
                authorized_organization_ids: number[];
                created_at: string;
                updated_at: string;
            } | null;
        }>(`${this.baseUrl}organizations/${organizationId}/customer-integration/`);
    }

    createOrganizationCustomerIntegration(
        organizationId: number,
        payload: {
            name: string;
            webhook_url: string;
            hmac_secret?: string;
            generate_hmac_secret?: boolean;
            is_active?: boolean;
        },
    ) {
        return this.http.post<{
            organization_id: number;
            environment: string;
            generated_hmac_secret?: string;
            integration: {
                id: number;
                name: string;
                webhook_url: string;
                hmac_secret_configured: boolean;
                hmac_secret_masked: string;
                environment: string;
                is_active: boolean;
                authorized_organization_ids: number[];
                created_at: string;
                updated_at: string;
            };
        }>(`${this.baseUrl}organizations/${organizationId}/customer-integration/`, payload);
    }

    getOrganizationCustomerIntegrationStatus(organizationId: number) {
        return this.http.get<{
            organization_id: number;
            environment: string;
            environment_resolved: boolean;
            unresolved_reason: string | null;
            integration_id: number | null;
            checklist: Array<{
                key: string;
                label: string;
                status: string;
                detail: string;
            }>;
            summary: {
                last_attempt_at: string | null;
                last_delivered_at: string | null;
                last_failure_at: string | null;
                last_error: string;
            };
            activity: Array<{
                kind: string;
                at: string | null;
                status: string;
                detail: string;
                event_id?: string;
                http_status?: number | null;
            }>;
        }>(`${this.baseUrl}organizations/${organizationId}/customer-integration/status/`);
    }

    getOrganizationCustomerIntegrationDeliveryHistory(
        organizationId: number,
        params: {
            page?: number;
            page_size?: number;
            outcome?: string;
            delivery_status?: string;
            event_id?: string;
            created_after?: string;
            created_before?: string;
        } = {},
    ) {
        const query: Record<string, string | number> = {};
        if (params.page != null) {
            query['page'] = params.page;
        }
        if (params.page_size != null) {
            query['page_size'] = params.page_size;
        }
        if (params.outcome) {
            query['outcome'] = params.outcome;
        }
        if (params.delivery_status) {
            query['delivery_status'] = params.delivery_status;
        }
        if (params.event_id) {
            query['event_id'] = params.event_id;
        }
        if (params.created_after) {
            query['created_after'] = params.created_after;
        }
        if (params.created_before) {
            query['created_before'] = params.created_before;
        }
        return this.http.get<{
            organization_id: number;
            results: Array<{
                vehicle_log_id: number;
                organization_id: number;
                event_id: string;
                history_at: string | null;
                classification: string;
                decision: {
                    id: number;
                    outcome: string;
                    outcome_label: string;
                    reason_code: string;
                    reason_label: string;
                    reason_detail: string;
                    created_at: string | null;
                } | null;
                deliveries: Array<{
                    id: number;
                    integration_id: number;
                    integration_name: string;
                    event_id: string;
                    status: string;
                    attempt_count: number;
                    created_at: string | null;
                    last_attempt_at: string | null;
                    delivered_at: string | null;
                    next_attempt_at: string | null;
                    last_http_status: number | null;
                    last_error: string;
                }>;
                vehicle_summary: {
                    vehicle_number: string;
                    direction: string;
                    camera_esn: string;
                    created_at: string | null;
                    event_source: string;
                };
            }>;
            page: number;
            page_size: number;
            total_records: number;
            total_pages: number;
        }>(`${this.baseUrl}organizations/${organizationId}/customer-integration/delivery-history/`, {
            params: query,
        });
    }

    generateCustomerIntegrationHmacSecret(
        integrationId: number,
        rotationRequestId: string,
    ) {
        return this.http.post<{
            generated_hmac_secret: string;
            integration: {
                id: number;
                name: string;
                webhook_url: string;
                hmac_secret_present?: boolean;
                hmac_secret_configured: boolean;
                hmac_secret_masked: string;
                environment: string;
                is_active: boolean;
                authorized_organization_ids: number[];
                created_at: string;
                updated_at: string;
            };
        }>(`${this.baseUrl}customer-integrations/${integrationId}/generate-hmac-secret/`, {
            rotation_request_id: rotationRequestId,
        });
    }

    linkOrganizationCustomerIntegration(organizationId: number, integrationId: number) {
        return this.http.post<{
            organization_id: number;
            environment: string;
            integration: {
                id: number;
                name: string;
                webhook_url: string;
                hmac_secret_configured: boolean;
                hmac_secret_masked: string;
                environment: string;
                is_active: boolean;
                authorized_organization_ids: number[];
                created_at: string;
                updated_at: string;
            };
        }>(`${this.baseUrl}organizations/${organizationId}/customer-integration/link/`, {
            integration_id: integrationId,
        });
    }

    unlinkOrganizationCustomerIntegration(organizationId: number, integrationId: number) {
        return this.http.post<{
            organization_id: number;
            integration_id: number;
            detail: string;
        }>(`${this.baseUrl}organizations/${organizationId}/customer-integration/unlink/`, {
            integration_id: integrationId,
        });
    }

    listCustomerIntegrations() {
        return this.http.get<{
            environment: string;
            results: Array<{
                id: number;
                name: string;
                webhook_url: string;
                hmac_secret_configured: boolean;
                hmac_secret_masked: string;
                environment: string;
                is_active: boolean;
                authorized_organization_ids: number[];
                created_at: string;
                updated_at: string;
            }>;
        }>(`${this.baseUrl}customer-integrations/`);
    }

    updateCustomerIntegration(
        integrationId: number,
        payload: Partial<{
            name: string;
            webhook_url: string;
            hmac_secret: string;
            is_active: boolean;
        }>,
    ) {
        return this.http.patch<{
            id: number;
            name: string;
            webhook_url: string;
            hmac_secret_configured: boolean;
            hmac_secret_masked: string;
            environment: string;
            is_active: boolean;
            authorized_organization_ids: number[];
            created_at: string;
            updated_at: string;
        }>(`${this.baseUrl}customer-integrations/${integrationId}/`, payload);
    }

    listCustomerIntegrationApiKeys(integrationId: number) {
        return this.http.get<Array<{
            id: number;
            key_prefix: string;
            masked_key: string;
            is_active: boolean;
            last_used_at: string | null;
            created_at: string;
        }>>(`${this.baseUrl}customer-integrations/${integrationId}/api-keys/`);
    }

    issueCustomerIntegrationApiKey(integrationId: number, payload: { is_active?: boolean } = {}) {
        return this.http.post<{
            id: number;
            key_prefix: string;
            masked_key: string;
            is_active: boolean;
            last_used_at: string | null;
            created_at: string;
            raw_key: string | null;
        }>(`${this.baseUrl}customer-integrations/${integrationId}/api-keys/`, payload);
    }

    updateCustomerIntegrationApiKey(
        integrationId: number,
        apiKeyId: number,
        payload: { is_active: boolean },
    ) {
        return this.http.patch<{
            id: number;
            key_prefix: string;
            masked_key: string;
            is_active: boolean;
            last_used_at: string | null;
            created_at: string;
        }>(`${this.baseUrl}customer-integrations/${integrationId}/api-keys/${apiKeyId}/`, payload);
    }

}
